import React from 'react';
const SvgChevronDown = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", focusable: false }, props),
    React.createElement("path", { d: "M16 25.757l-16-16 2.91-2.9L16 19.937l13.09-13.08 2.91 2.9z", fillRule: "evenodd" })));
export default SvgChevronDown;
//# sourceMappingURL=ChevronDown.js.map